import { type PropsWithChildren, useContext } from 'react';
import { MenuContext, Provider, type SelectionMode } from 'react-aria-components';

export function MenuContent({ children, selectionMode }: PropsWithChildren<{ selectionMode?: SelectionMode }>) {
  const context = useContext(MenuContext);
  return <Provider values={[[MenuContext, { ...context, selectionMode }]]}>{children}</Provider>;
}
